import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Link, useNavigate } from "react-router-dom";
import * as yup from "yup";
import { api } from "../../../api/apiService";
import { toast } from "react-toastify";

const Register = () => {
  const schema = yup.object().shape({
    first_name: yup.string().required("First Name is required"),
    last_name: yup.string().required("Last Name is required"),
    email: yup
      .string()
      .email("Invalid email format")
      .required("Email is required"),
    password: yup
      .string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is required"),
    password_confirmation: yup
      .string()
      .oneOf([yup.ref("password")], "Passwords must match")
      .required("Password confirmation is required"),
    terms: yup.boolean().oneOf([true], "You must accept the terms and conditions"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      const response = await api.post("/register", data);
      toast.success("Account created successfully");
      navigate("/login");
    } catch (error) {
      if (error.data && error.data.errors) {
        error.data.errors.forEach(err => {
          toast.error(err);
        });
      } else {
        toast.error("Registration failed");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-lg-6 col-md-8">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title text-center">Create Your Account</h5>
              <form className="row g-3 needs-validation" onSubmit={handleSubmit(onSubmit)}>
                {/* First Name */}
                <div className="col-6">
                  <label htmlFor="firstName" className="form-label">
                    First Name
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    className={`form-control ${errors.first_name ? "is-invalid" : ""}`}
                    {...register("first_name")}
                  />
                  {errors.first_name && (
                    <div className="invalid-feedback">{errors.first_name.message}</div>
                  )}
                </div>

                {/* Last Name */}
                <div className="col-6">
                  <label htmlFor="lastName" className="form-label">
                    Last Name
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    className={`form-control ${errors.last_name ? "is-invalid" : ""}`}
                    {...register("last_name")}
                  />
                  {errors.last_name && (
                    <div className="invalid-feedback">{errors.last_name.message}</div>
                  )}
                </div>

                {/* Email */}
                <div className="col-12">
                  <label htmlFor="email" className="form-label">
                    Your Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    className={`form-control ${errors.email ? "is-invalid" : ""}`}
                    {...register("email")}
                  />
                  {errors.email && <div className="invalid-feedback">{errors.email.message}</div>}
                </div>

                {/* Password */}
                <div className="col-12">
                  <label htmlFor="password" className="form-label">
                    Password
                  </label>
                  <input
                    type="password"
                    id="password"
                    className={`form-control ${errors.password ? "is-invalid" : ""}`}
                    {...register("password")}
                  />
                  {errors.password && (
                    <div className="invalid-feedback">{errors.password.message}</div>
                  )}
                </div>

                {/* Confirm Password */}
                <div className="col-12">
                  <label htmlFor="passwordConfirmation" className="form-label">
                    Confirm Password
                  </label>
                  <input
                    type="password"
                    id="passwordConfirmation"
                    className={`form-control ${errors.password_confirmation ? "is-invalid" : ""
                      }`}
                    {...register("password_confirmation")}
                  />
                  {errors.password_confirmation && (
                    <div className="invalid-feedback">{errors.password_confirmation.message}</div>
                  )}
                </div>

                {/* Terms and Conditions */}
                <div className="col-12">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      id="acceptTerms"
                      className={`form-check-input ${errors.terms ? "is-invalid" : ""}`}
                      {...register("terms")}
                    />
                    <label htmlFor="acceptTerms" className="form-check-label">
                      I agree and accept the <a href="#">terms and conditions</a>
                    </label>
                    {errors.terms && <div className="invalid-feedback">{errors.terms.message}</div>}
                  </div>
                </div>

                {/* Submit Button */}
                <div className="col-12">
                  <button
                    className="btn btn-primary w-100"
                    type="submit"
                    disabled={isLoading || !isValid}
                  >
                    {isLoading ? "Creating Account..." : "Create Account"}
                  </button>
                </div>

                {/* Login Redirect */}
                <div className="col-12">
                  <p className="small mb-0">
                    Already have an account? <Link to="/login">Login</Link>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
